import script from "./useRules.vue?vue&type=script&setup=true&lang=js"
export * from "./useRules.vue?vue&type=script&setup=true&lang=js"

import "./useRules.vue?vue&type=style&index=0&id=2c99ae38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c99ae38"]])

export default __exports__